export enum ConstructionLogControlName {
  InvestorDetails = 'investorDetails',
  ProxyDetailsCheckbox = 'proxyDetailsCheckbox',
  ProxyDetails = 'proxyDetails',
  DecisionNumber = 'decisionNumber',
  DecisionDate = 'decisionDate',
  DecisionPublishedBy = 'decisionPublishedBy',
  ConstructionLogType = 'constructionLogType'
}
